/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const moduleName = 'gslb';
const componentName = 'gslb-sites-list-page';

const prefix = `${moduleName}.${componentName}`;

export const headerLabel = `${prefix}.headerLabel`;
export const passiveLabel = `${prefix}.passiveLabel`;
export const leaderLabel = `${prefix}.leaderLabel`;
export const thirdPartyLabel = `${prefix}.thirdPartyLabel`;
export const thirdPartySiteLabel = `${prefix}.thirdPartySiteLabel`;
export const newSiteLabel = `${prefix}.newSiteLabel`;
export const editGslbSetting = `${prefix}.editGslbSetting`;
export const replicationLabel = `${prefix}.replicationLabel`;
export const replicationModeLabel = `${prefix}.replicationModeLabel`;
export const dnsVsLabel = `${prefix}.dnsVsLabel`;
export const deleteGSLBConfigurationsMessage = `${prefix}.deleteGSLBConfigurationsMessage`;
export const columnValueSuffix = `${prefix}.columnValueSuffix`;
export const enableLabel = `${prefix}.enableLabel`;
export const deactivateLabel = `${prefix}.deactivateLabel`;
export const continuousReplicationLabel = `${prefix}.continuousReplicationLabel`;
export const adaptiveReplicationLabel = `${prefix}.adaptiveReplicationLabel`;
export const manualReplicationLabel = `${prefix}.manualReplicationLabel`;
export const gridHeader = `${prefix}.gridHeader`;
export const createLeaderSiteLabel = `${prefix}.createLeaderSiteLabel`;
export const gslbLabel = `${prefix}.gslbLabel`;
export const gslbCreateLeaderSiteText = `${prefix}.gslbCreateLeaderSiteText`;
export const gslbGuideLinkText = `${prefix}.gslbGuideLinkText`;
export const toConfigureText = `${prefix}.toConfigureText`;
export const currentLabel = `${prefix}.currentLabel`;

export const ENGLISH = {
    [headerLabel]: 'Sites',
    [passiveLabel]: 'Passive',
    [leaderLabel]: 'Leader',
    [thirdPartyLabel]: 'Third-Party',
    [thirdPartySiteLabel]: 'Third-Party Site',
    [newSiteLabel]: 'New Site',
    [editGslbSetting]: 'Edit GSLB Setting',
    [replicationLabel]: 'Replication',
    [replicationModeLabel]: 'Replication Mode',
    [dnsVsLabel]: 'DNS VS',
    [deleteGSLBConfigurationsMessage]: 'All GSLB Site configuration will be removed.',
    [columnValueSuffix]: '(+{0} More)',
    [enableLabel]: 'Enable',
    [deactivateLabel]: 'Deactivate',
    [continuousReplicationLabel]: 'Continuous Replication',
    [adaptiveReplicationLabel]: 'Adaptive Replication',
    [manualReplicationLabel]: 'Manual Replication',
    [gridHeader]: 'Sites ({1})',
    [createLeaderSiteLabel]: 'Create Leader Site',
    [gslbLabel]: 'GSLB',
    [gslbCreateLeaderSiteText]: 'The Global Server Load Balancing (GSLB) configuration for Avi Load Balancer has been deactivated. Please refer to the <a href="{0}" target="_blank">GSLB configuration guide</a> to configure it.',
    [currentLabel]: 'Current',
};
